import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { MeService } from './service/me.service';
import { Profile } from './model/profile.model';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ SidebarComponent ],
    providers : [MeService, Profile],
    exports: [ SidebarComponent ]
})

export class SidebarModule {}
